import { render, staticRenderFns } from "./companyChange.vue?vue&type=template&id=5447b34e&scoped=true&"
import script from "./companyChange.vue?vue&type=script&lang=js&"
export * from "./companyChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447b34e",
  null
  
)

export default component.exports